/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Susbewerberstatus2Inputs */



/**

* @param {_Field_Susbewerberstatus2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_susbewerberstatus2 = /** @type {((inputs?: _Field_Susbewerberstatus2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Susbewerberstatus2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Bewerbungsstatus")
});
export { _field_susbewerberstatus2 as "_field_susBewerberStatus" }